export default "__VITE_ASSET__BhlhzIMS__"